import styled from "styled-components";
import spacing from "theme/spacing.module.scss";
import colors from "theme/colors.module.scss";
import shadows from "theme/shadows.module.scss";
import { BaseTypeProps, ProgressBarProps, ToastType } from "./types";

export const MainWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: ${spacing.spacingXS};
    position: fixed;
    bottom: 85px;
    left: 50%;
    z-index: 1201; // ponad modalem
    transform: translateX(-50%);
    background-color: ${colors.primaryBackground};
    border-radius: 4px;
    box-shadow: ${shadows.primaryShadow};
    min-width: 250px;
    height: fit-content;
`;

export const ContentWrapper = styled.div<BaseTypeProps>`
    display: flex;
    align-items: center;
    gap: ${spacing.spacingXS};
    padding: ${spacing.spacing};
    
    svg {
        cursor: pointer;
        fill: ${({ $type }) =>
          $type === ToastType.FAILURE ? colors.accentRed500 : colors.accentSuccess500};
    }
`;

export const ProgressBarWrapper = styled.div`
    display: flex;
    width: 100%;
`

export const ProgressBar = styled.div<ProgressBarProps>`
    height: 2px;
    background-color: ${({ $type }) =>
      $type === ToastType.FAILURE ? colors.accentRed500: colors.accentSuccess700};
    width: ${({ $width }) => 100 - $width || 0}%;
    transition: width 0.1s linear;
`;